import React from "react"

import "./toggleprodbtn.scss"

/**
 * Button to switch between product parts
 * @component
 * @param  {object} props
 * @param  {function} props.handler - handler button onclick function
 * @param  {string} props.url - icon url for button icon
 * @param  {string} props.name - value for function work
 * @param  {boolean} props.active - button state
 *
 * @example
 * const handler = () => {}
 * const name = 'string'
 * const url = './src'
 * const active = false
 *
 * return (
 *  <ToggleProdBtn
 *    handler={handler}
 *    name ={name}
 *    url={url}
 *    active={active}
 *  />
 * )
 */

const ToggleProdBtn = props => {
  const {handler = () => {}, url = "", name = "", active = false} = props
  return (
    <button
      onClick={handler}
      className={`toggleProdBtnContainer ${active && "toggleProdBtnActive"}`}
      disabled={active}
      data-value={name}
    >
      <img src={url} alt={name} />
      <span>{name}</span>
    </button>
  )
}

export default ToggleProdBtn
